import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import CloseButton from "./CloseButton";

export const modalStyles = ({
  maxWidth = "620px",
  styles = {
    top: "2%",
  },
} = {}) => {
  return {
    overlay: {
      backgroundColor: "rgba(25,62,93, 0.6)",
      boxShadow: "0 7px 74px 0 rgba(0, 0, 0, 0.3)",
      zIndex: "1040",
    },
    content: {
      maxWidth: maxWidth,
      padding: "0px",
      display: "flex",
      flexDirection: "column",
      ...styles,
    },
  };
};

/**
 * Tg Modal
 */
const TgModal = ({
  children,
  isOpen,
  closeModal,
  afterOpenModal,
  maxWidth = "620px",
  childrenPadding = "p-6",
  shouldCloseOnOverlayClick = true,
  overFlowY = "overflow-y-auto",
  overFlowChildren = "overflow-auto",
}) => {
  const AppElement = document.querySelector("body");

  return (
    <Modal
      appElement={AppElement}
      isOpen={isOpen}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onRequestClose={closeModal}
      style={modalStyles({ maxWidth })}
      contentLabel=""
      className="Modal__Content sm:rounded-3xlh"
      overlayClassName="Modal__Overlay"
      onAfterClose={() => (document.body.style.overflow = "unset")}
      onAfterOpen={() => {
        document.body.style.overflow = "hidden";
        afterOpenModal();
      }}
    >
      <div
        className={`overflow-x-hidden ${overFlowY} align-center content-wrapper sm:rounded-3xl sm:my-0`}
        role="dialog"
        aria-modal="true"
        aria-labelledby=""
      >
        <div className="modal-header flex justify-end">
          <CloseButton onClick={closeModal} />
        </div>
        <div className="modal-body">
          <div
            className={`content-center mx-auto ${childrenPadding} ${overFlowChildren}`}
          >
            {children}
          </div>
        </div>
      </div>
    </Modal>
  );
};

TgModal.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  afterOpenModal: PropTypes.func,
  maxWidth: PropTypes.string,
  childrenPadding: PropTypes.string,
  shouldCloseOnOverlayClick: PropTypes.bool,
  overFlowY: PropTypes.string,
  overFlowChildren: PropTypes.string,
};

export default TgModal;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/TgModal/index.jsx